import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { getButton } from 'Shared/GTM/getButton'
import { history } from '../../redux'

const defaultState = {
  showIuppMobileMenu: false
}

const IuppHeaderMenuMobileDisconnected = ({ meuBairro }) => {
  const [ownState, setOwnState] = useState(defaultState)

  const toggleMenuMobileIupp = () => {
    if (!ownState.showIuppMobileMenu) {
      const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] .home-disconnected, [role="main"] .home-disconnected section, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div h1, [role="main"] .home-disconnected section div button, [role="main"] .home-disconnected section div h2 , [role="main"] .home-disconnected section div ul, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div ul li, [role="main"] .home-disconnected section div ul li img, [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button, .iupp-header nav, footer, footer div, footer div p, footer div a, footer div h3, footer div ul, footer div ul li, footer div ul li a')
      if (allButtonsAndLinks.length > 0) {
        Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
          buttonOrLink.setAttribute('aria-hidden', 'true')
          buttonOrLink.setAttribute('tabindex', '-1')
          document.getElementById('header').removeAttribute('aria-hidden')
          document.getElementById('header-disconnected').removeAttribute('aria-hidden')
          document.querySelector('nav.collapseMenuMobile').removeAttribute('aria-hidden')
          document.querySelector('nav.collapseMenuMobile a').removeAttribute('aria-hidden')
          document.querySelector('a.abrir-menu').removeAttribute('aria-hidden')

          if (meuBairro) {
            document.querySelector('a.mn-benefits').removeAttribute('aria-hidden')
            document.querySelector('a.mn-accumulate-help').removeAttribute('aria-hidden')
          } else {
            document.querySelector('a.mn-experiences').removeAttribute('aria-hidden')
            document.querySelector('a.mn-accumulate-points').removeAttribute('aria-hidden')
            document.querySelector('a.mn-use-points').removeAttribute('aria-hidden')
            document.querySelector('a.mn-benefits').removeAttribute('aria-hidden')
          }

          document.getElementById('mainContainer').classList.add('d-none')
          document.getElementById('footer').classList.add('d-none')
          setTimeout(() => {
            document.querySelector('a.close-menu').focus()
            document.querySelector('a.abrir-menu').setAttribute('aria-hidden', 'true')
          })
        })
      }
    } else {
      const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] .home-disconnected, [role="main"] .home-disconnected section, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div h1, [role="main"] .home-disconnected section div button, [role="main"] .home-disconnected section div h2 , [role="main"] .home-disconnected section div ul, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div ul li, [role="main"] .home-disconnected section div ul li img, [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button, .iupp-header nav, footer, footer div, footer div p, footer div a, footer div h3, footer div ul, footer div ul li, footer div ul li a')
      if (allButtonsAndLinks.length > 0) {
        Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
          buttonOrLink.removeAttribute('aria-hidden')
          buttonOrLink.removeAttribute('tabindex')
          document.getElementById('mainContainer').classList.remove('d-none')
          document.getElementById('footer').classList.remove('d-none')
          setTimeout(() => {
            document.querySelector('a.abrir-menu').focus()
          })
        })
      }
    }

    setOwnState({
      ...ownState,
      showIuppMobileMenu: !ownState.showIuppMobileMenu
    })
  }

  const keyPressMenu = (e) => {
    if (e.which === 13) {
      toggleMenuMobileIupp()
    }
  }

  const toggleAnchorLink = (section) => {
    document.getElementById('mainContainer').classList.remove('d-none')
    document.getElementById('footer').classList.remove('d-none')

    if (
      section === '#experiences' ||
      section === '#accumulatePoints' ||
      section === '#usePoint' ||
      section === '#benefits' ||
      section === '#help'
    ) {
      setTimeout(() => {
        document.querySelector(`a.menu-login`).blur()
        document.querySelector(`${section} h2`).setAttribute('tabindex', '0')
        document.querySelector(`${section} h2`).focus()
        document.querySelector(`${section} h2`).addEventListener('blur', function () {
          document.querySelector(`${section} h2`).removeAttribute('tabindex')
        })

        setOwnState({
          ...ownState,
          showIuppMobileMenu: false
        })
      }, 100)

      const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] .home-disconnected, [role="main"] .home-disconnected section, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div h1, [role="main"] .home-disconnected section div button, [role="main"] .home-disconnected section div h2 , [role="main"] .home-disconnected section div ul, [role="main"] .home-disconnected section div, [role="main"] .home-disconnected section div ul li, [role="main"] .home-disconnected section div ul li img, [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button, .iupp-header nav, footer, footer div, footer div p, footer div a, footer div h3, footer div ul, footer div ul li, footer div ul li a')
      if (allButtonsAndLinks.length > 0) {
        Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
          buttonOrLink.removeAttribute('aria-hidden')
          buttonOrLink.removeAttribute('tabindex')
        })
      }
    }
  }

  const returnHome = () => {
    if (meuBairro) history.push('/meu-negocio')
    else history.push('/')
  }

  const personalMenuItems = [
    {
      text: 'Experiências',
      link: '#experiences',
      label: 'experiencias',
      personalClass: 'mn-experiences'
    },
    {
      text: 'Junte pontos',
      link: '#accumulatePoints',
      label: 'junte-pontos',
      personalClass: 'mn-accumulate-points'
    },
    {
      text: 'Use pontos',
      link: '#usePoint',
      label: 'use-pontos',
      personalClass: 'mn-use-points'
    },
    {
      text: 'Descontos',
      link: '#benefits',
      label: 'beneficios',
      personalClass: 'mn-benefits'
    }
  ]

  const businessMenuItems = [
    {
      text: 'Benefícios',
      link: '#benefits',
      label: 'benefícios',
      personalClass: 'mn-benefits'
    },
    {
      text: 'Dúvidas frequentes',
      link: '#help',
      label: 'dúvidas frequentes',
      personalClass: 'mn-accumulate-help'
    }
  ]

  const menuDisconnected = meuBairro ? businessMenuItems : personalMenuItems

  return (
    <Fragment>
      <a
        id='abrir-menu'
        className='color-ui-white txt-body-sm pos-absolute l-2 hamburger-menu abrir-menu'
        onClick={() => {
          toggleMenuMobileIupp()
          getButton(false, 'home', 'clique:menu', 'menu')
        }}
        onKeyPress={keyPressMenu}
        tabIndex={!ownState.showIuppMobileMenu ? 0 : -1}
        aria-label={ownState.showIuppMobileMenu ? 'Menu expandido' : 'Menu'}
        aria-controls='collapseMenuMobile'
        role='button'
        aria-haspopup='true'
        aria-expanded={ownState.showIuppMobileMenu}
      >
        <i className={'color-brand-5 icon icon_menu_app'} aria-hidden='true' />
      </a>

      <div className={`menu-mobile-iupp ${ownState.showIuppMobileMenu ? 'open-menu-iupp' : 'd-none close-menu-iupp'}`} tab-index={`${ownState.showIuppMobileMenu ? '0' : '-1'}`}>
        <div className='menu-mobile menu'>
          <nav aria-label='Menu' id='collapseMenuMobile' className='row h-100 collapseMenuMobile' arial-label='menu'>
            <div className='col-12'>
              <ul>
                <li className='close-hamburger-menu bg-brand-4 color-ui-white px-2'>
                  <a
                    href='#'
                    id='close-menu'
                    onClick={() => {
                      toggleMenuMobileIupp()
                      getButton(false, 'home', 'clique:menu', 'close-menu')
                    }}
                    onKeyPress={keyPressMenu}
                    className={`link-font-mobile mn-item color-ui-white close-menu`}
                    tabIndex={ownState.showIuppMobileMenu ? 0 : -1}
                    aria-label='Fechar menu'
                  >
                    <i className='icon icon_left_app color-ui-white mr-1' aria-hidden='true' />
                    <span className='link-font-mobile color-ui-white'>Fechar menu</span>
                  </a>
                </li>
                {history.location.pathname === '/' || history.location.pathname === '/meu-negocio' ? (
                  menuDisconnected.map((e, i) => {
                    return (
                      <li
                        className='mx-2 border-bottom border-color-ui-2'
                        key={i}
                      >
                        <AnchorLink
                          onClick={() => {
                            toggleAnchorLink(e.link)
                            getButton(false, 'home', 'clique:menu', e.label)
                          }}
                          href={e.link}
                          data-target={e.link}
                          className={`link-font-mobile mn-item mx-0 px-0 ${e.personalClass}`}
                          tabIndex={ownState.showIuppMobileMenu ? 0 : -1}
                          aria-label={e.text}
                        >
                          {e.text}
                        </AnchorLink>
                      </li>
                    )
                  })
                ) : (
                  menuDisconnected.map((e, i) => {
                    return (
                      <li
                        className='mx-2 border-bottom border-color-ui-2'
                        key={i}
                      >
                        <a
                          onClick={() => {
                            returnHome()
                            toggleMenuMobileIupp(e.link)
                            getButton(false, 'home', 'clique:menu', e.label)
                          }}
                          href={e.link}
                          data-target={e.link}
                          className={`link-font-mobile mn-item ${e.personalClass}`}
                          tabIndex={0}
                          target='_blank'
                        >
                          {e.text}
                        </a>
                      </li>
                    )
                  })
                )}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </Fragment>
  )
}

IuppHeaderMenuMobileDisconnected.propTypes = {
  meuBairro: PropTypes.bool.isRequired
}

export default IuppHeaderMenuMobileDisconnected



// WEBPACK FOOTER //
// ./src/App/Header/IuppHeaderMenuMobileDisconnected.js